module.exports = __webpack_public_path__ + "static/media/room.3accab2a.jpg";